export default __webpack_public_path__ + "static/media/Kanyakumari.3a68686f.png";